import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';


export interface EzoTmplParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface EzoTmpl {
  id?:number;
  templateName:string;
  templateType?:string;
templateSubType?:string;
templateCode?:string;
templateDescription?:string;
activeFlag?:string;
suggestionNotes?:string;
  createdBy:number;
  createdDate:Date
  updatedBy:number;
  updatedDate:Date
  createdIP?:string;
  updatedIP?:string;
  fileName?:string;
  fileLocation?:string;
ContainerName?:string;
  parameters?: EzoTmplParameter[];
  links?: any;
}


export abstract class EzoTmplData { 
  abstract list(url: string): Observable<any[]>;
  abstract create(url: string,data: EzoTmpl): Observable<any>;
  abstract update(url: string,data: EzoTmpl): Observable<any>;
  abstract delete(url: string): Observable<any>;
}